import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user';
import baseInfo from './modules/baseInfo';
import common from './modules/common';

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    baseInfo,
    common,
  },
})

export default store